import type { FC } from 'react';
import { Box } from '@mui/material';

import { SkeletonBlock } from '../../atoms/SkeletonBlock';

import {
	StyledCard,
	StyledHeader,
	StyledPriceRow,
	StyledTitleGroup,
	StyledValiditySection,
} from './MplTicketshopCard.styled';

interface IMplTicketshopCardSkeletonProps {
	dataTestId?: string;
}

interface ISkeletonTextLineProps {
	lineHeight: number;
	width: string | number;
	/** Bar thickness; defaults to the font glyph height so it reads as text. */
	barHeight?: number;
}

const SkeletonTextLine: FC<ISkeletonTextLineProps> = ({
	lineHeight,
	width,
	barHeight = 14,
}) => (
	<Box sx={{ height: lineHeight, display: 'flex', alignItems: 'center' }}>
		<SkeletonBlock w={width} h={barHeight} r={6} />
	</Box>
);

export const MplTicketshopCardSkeleton: FC<IMplTicketshopCardSkeletonProps> = ({
	dataTestId,
}) => {
	return (
		<StyledCard data-testid={dataTestId}>
			<StyledHeader>
				<SkeletonBlock w={48} h={48} r={24} />
				<StyledTitleGroup>
					<SkeletonTextLine lineHeight={24} width="60%" barHeight={16} />
					<SkeletonTextLine lineHeight={18} width="40%" barHeight={12} />
				</StyledTitleGroup>
				<SkeletonBlock w={64} h={24} r={12} />
			</StyledHeader>

			<StyledValiditySection>
				<SkeletonTextLine lineHeight={21} width="80%" />
				<SkeletonTextLine lineHeight={21} width="55%" />
				<SkeletonTextLine lineHeight={21} width="45%" />
			</StyledValiditySection>

			<StyledPriceRow>
				<SkeletonTextLine lineHeight={24} width="35%" barHeight={16} />
				<SkeletonTextLine lineHeight={24} width="20%" barHeight={16} />
			</StyledPriceRow>
		</StyledCard>
	);
};
